module.exports = __webpack_public_path__ + "static/media/analytics.7cce40d9.png";